import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import ScriptLoader from 'yoda-core-components/lib/helpers/ScriptLoader/ScriptLoader';
import { selectQueryParams } from 'yoda-site-components/lib/selectors/QuerySelector';
import { selectPreferences } from 'yoda-site-components/lib/selectors/ContextSelector';
import {
    initProductOptions,
    getFilteredSkuId,
    getSelectedProductSku,
} from 'yoda-site-components/lib/selectors/ProductOptionsSelector';

import {
    VTO_CONTAINER_ID,
    COLOR_UNAVAILABLE_MESSAGE,
    COLOR_UNAVAILABLE,
    GENERIC_ERROR_MESSAGE,
} from '../../helpers/VTOConstants';
import {
    setCurrentVto,
    toggleVto,
    resetVtoMessage,
    setVtoMessage,
} from '../../actions/VirtualTryOnAction';
import virtualTryOnDataSelector from '../../selectors/VirtualTryOnSelector';
import { getProductSKUs } from '../../selectors/ProductDetails/ProductDetailsSelector';
import * as styles from './VirtualTryOn.css';

const cx = classNames.bind(styles);
export class VirtualTryOn extends Component {
    static defaultProps = {
        preferences: {},
        vtoSelectedSku: '',
        defaultLotFirstSku: '',
        queryParams: {},
        productOptions: {},
        virtualTryOn: {},
        pricingURL: {},
        productSKUs: [],
    };

    static propTypes = {
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        preferences: PropTypes.oneOfType([PropTypes.object]),
        vtoSelectedSku: PropTypes.string,
        defaultLotFirstSku: PropTypes.string,
        queryParams: PropTypes.oneOfType([PropTypes.object]),
        productOptions: PropTypes.oneOfType([PropTypes.object]),
        virtualTryOn: PropTypes.oneOfType([PropTypes.object]),
        pricingURL: PropTypes.oneOfType([PropTypes.object]),
        productSKUs: PropTypes.array,
    };

    constructor() {
        super();
        this.revieve = null;
        this.liveAR = null;
        this.revieveAPI = null;
    }

    componentDidMount() {
        this.loadScript();
    }

    // eslint-disable-next-line react/no-deprecated
    componentWillReceiveProps(nextProps) {
        try {
            const {
                virtualTryOn: { data: nextData = {} },
                productOptions: { option: nextOption = '' },
            } = nextProps;
            const {
                virtualTryOn: { data = {} },
                productOptions: { option = '' },
                actions,
            } = this.props;
            /* istanbul ignore else */
            if (
                typeof data.enabled === 'undefined' &&
                nextData.enabled === true &&
                nextData.vtoAvailabilityCurrentSKU
            ) {
                this.revieveAPI.show && this.revieveAPI.show();
            }

            /* istanbul ignore else */
            if (nextOption !== option) {
                const messages = get(this.props.virtualTryOn, 'data.messages', []);
                messages.length > 0 && actions.resetVtoMessage();
            }
        } catch (e) {
            this.revieveAPI.unmount && this.revieveAPI.unmount();
            this.loadVTO(true);
        }
    }

    shouldComponentUpdate(nextProps) {
        const {
            productOptions: { option: nextOption },
            virtualTryOn: { data: nextData = {} },
            pricingURL: { itemOfferingCall: nextItemOfferingCall = false },
        } = nextProps;
        const {
            productOptions: { option },
            virtualTryOn: { data = {} },
            pricingURL: { itemOfferingCall = false },
        } = this.props;
        return (
            nextOption !== option ||
            data.enabled !== nextData.enabled ||
            nextItemOfferingCall !== itemOfferingCall
        );
    }

    componentDidUpdate() {
        this.checkTryOnAvailable(this.props.vtoSelectedSku);
    }

    checkTryOnAvailable = (skuId, onPageLoad = false) => {
        try {
            const { preferences } = this.props;
            const vtoPerf = get(preferences, 'virtualTryOnPDP', {});
            const {
                actions,
                pricingURL: { itemOfferingCall = false },
            } = this.props;
            if ((!skuId || !itemOfferingCall) && !onPageLoad) {
                this.liveAR && this.liveAR.resetTryOnProducts && this.liveAR.resetTryOnProducts();
            } else {
                /* istanbul ignore next */
                this.liveAR &&
                    this.liveAR.isTryOnAvailable &&
                    this.liveAR.isTryOnAvailable(
                        { product_id: skuId, env: vtoPerf.env, partner_id: vtoPerf.partnerId },
                        (available) => {
                            const payload = {
                                currentSku: skuId,
                            };
                            if (available) {
                                this.liveAR &&
                                    this.liveAR.addTryOnProduct &&
                                    this.liveAR.addTryOnProduct(skuId);
                                payload.vtoAvailabilityCurrentSKU = true;
                                if (onPageLoad) {
                                    payload.vtoAvailabilityForPP = true;
                                    payload.skuPPLevel = skuId;
                                }
                                actions.setCurrentVto(payload);
                                return true;
                            }
                            this.liveAR &&
                                this.liveAR.resetTryOnProducts &&
                                this.liveAR.resetTryOnProducts();
                            payload.vtoAvailabilityCurrentSKU = false;
                            if (onPageLoad) {
                                payload.vtoAvailabilityForPP = false;
                                payload.skuPPLevel = skuId;
                            } else {
                                this.dispalayMessage(COLOR_UNAVAILABLE);
                            }
                            actions.setCurrentVto(payload);
                            return false;
                        }
                    );
            }
        } catch (e) {
            this.revieveAPI.unmount && this.revieveAPI.unmount();
            this.loadVTO(true);
        }
    };

    dispalayMessage = (messageType = '') => {
        const { actions } = this.props;
        const vtoPerf = get(this.props.preferences, 'virtualTryOnPDP', {});
        let body = '';
        switch (messageType) {
            case COLOR_UNAVAILABLE:
                body = get(vtoPerf, 'messages.colorUnavailable', COLOR_UNAVAILABLE_MESSAGE);
                break;
            default:
                body = get(vtoPerf, 'messages.genericMessage', GENERIC_ERROR_MESSAGE);
                break;
        }
        const messagesPayload = {
            id: 'vtoErrorMessage',
            body,
            type: 'info',
        };
        actions.setVtoMessage(messagesPayload);
    };

    getConfig = () => {
        const { preferences, actions } = this.props;
        const vtoPerf = get(preferences, 'virtualTryOnPDP', {});
        return {
            partner_id: vtoPerf.partnerId ? vtoPerf.partnerId : '',
            locale: vtoPerf.locale ? vtoPerf.locale : 'en',
            disablePersist: vtoPerf.disablePersist ? vtoPerf.disablePersist : false, // Don't persist state
            env: vtoPerf.env ? vtoPerf.env : 'test',
            renderTo: document.getElementById(VTO_CONTAINER_ID),
            /* istanbul ignore next */
            onClose: () => {
                actions.toggleVto &&
                    actions.toggleVto({
                        enabled: false,
                    });
            },
        };
    };

    loadScript = () => {
        const { preferences } = this.props;
        const vtoRevieveURL = get(preferences, 'virtualTryOnPDP.rvConfig.vtoURL', '');
        const vtoRevieveProps = {
            src: vtoRevieveURL,
            async: true,
            defer: false,
            onSuccess: () => {
                /* istanbul ignore next */
                this.loadVTO();
            },
        };
        ScriptLoader.load(vtoRevieveProps);
    };

    loadVTO = (onError = false) => {
        /* istanbul ignore else */
        if (!__SERVER__) {
            const {
                defaultLotFirstSku,
                preferences,
                queryParams,
                vtoSelectedSku,
                productSKUs,
            } = this.props;
            const config = this.getConfig();
            let skuId = '';
            if (queryParams.selectedSKUId) {
                skuId = queryParams.selectedSKUId;
            } else if (vtoSelectedSku) {
                skuId = vtoSelectedSku;
            } else {
                skuId = defaultLotFirstSku;
            }
            /* istanbul ignore next */
            // eslint-disable-next-line no-multi-assign
            if (window && window.Revieve) {
                this.revieve = window.Revieve;
                this.revieveAPI = this.revieve && this.revieve.API;
                this.liveAR = this.revieveAPI && this.revieveAPI.liveAR;

                this.revieve.Init(config, () => {
                    this.liveAR.loadTryOnProducts && this.liveAR.loadTryOnProducts(productSKUs);
                    this.checkTryOnAvailable(skuId, true);
                    onError && this.revieveAPI.show && this.revieveAPI.show();
                    onError && this.dispalayMessage();
                });
            }
        }
    };

    render() {
        const toggleEnabled = get(this.props.virtualTryOn, 'data.enabled', false);
        return (
            <div
                id="revieve-container"
                className={dt([
                    'h-full',
                    'smMd:w-full',
                    'lg:w-[calc(100%-16px)]',
                    'relative',
                    'pb-[100%]',
                    toggleEnabled ? 'block' : 'hidden',
                ])}
            />
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            setCurrentVto,
            toggleVto,
            resetVtoMessage,
            setVtoMessage,
        },
        dispatch
    ),
});

const mapStateToProps = (state) => ({
    preferences: selectPreferences(state),
    vtoSelectedSku: getFilteredSkuId(false)(state),
    queryParams: selectQueryParams(state),
    productOptions: state.productOptions,
    virtualTryOn: virtualTryOnDataSelector(state),
    pricingURL: initProductOptions(false)(state).pricingURL,
    defaultLotFirstSku: getSelectedProductSku(false)(state),
    productSKUs: getProductSKUs(false)(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(VirtualTryOn);
